import { API_CALL } from '../../../../../middleware/api';
import { WIDGET_GET_HUBS_WITHOUT_READINGS_COUNT } from './constants';

export const actions = {
  getHubsWithoutReadings: request => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/hubs-without-readings',
      params: request,

    },
    type: WIDGET_GET_HUBS_WITHOUT_READINGS_COUNT,
  }),
};
